import {createFetcher} from "../../../../tools/fetcher/fetcher";

export const refreshAuthToken = async (auth) => {
    return await createFetcher({}).post(`/api/user/sign-in/refresh`);
};
